import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import AuthBootstrap from './components/AuthBootstrap/AuthBootstrap'
import './tokens/shared.css'
import './styles/theme.css'
import './styles/viewport-shell.css'

// Load Telegram WebApp SDK only when inside Telegram Mini App
if (window.location.search.includes('tgWebAppData') || window.location.pathname === '/tg') {
  const s = document.createElement('script')
  s.src = 'https://telegram.org/js/telegram-web-app.js'
  s.defer = true
  document.head.appendChild(s)
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthBootstrap>
          <App />
        </AuthBootstrap>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)